export const state = {
    searchClient: []
};
  
export const mutations = {
    SET_SEARCH_CLIENT(state, detail) {
        state.searchClient.unshift(detail)

        const userdata = JSON.parse(localStorage.getItem('userdata'))
        let maxSize = 5;
        if (userdata.role_name != 'dealer') {
            maxSize = 10;
        }
          
        if(state.searchClient.length > maxSize)   
            state.searchClient = state.searchClient.slice(0,-1)
      
    },
    UPDATE_ITEM(state, payload) {
        const { rowId, expiredate } = payload;
        const item = state.searchClient[rowId];
        if (item) {
          item.expiredate = expiredate;
        }
    },
    EMPTY(state) {
        state.searchClient = []
    },
    REMOVE_LINE(state, idx) {
        state.searchClient.splice(idx, 1)
    }
};

export const actions = {
    setSearchClient({ commit }, detail) {
        commit('SET_SEARCH_CLIENT', detail);
    },
    updateItemName({ commit },  payload) {
       commit('UPDATE_ITEM', payload);
    },
    empty({ commit }) {
        commit('EMPTY');
    },
    removeLine({ commit }, idx) {
        commit('REMOVE_LINE', idx);
    }
};

export const getters = {
    getSearchClient: state => state.searchClient
};

  